import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import Banner from '../../components/tribe/tribe_banner'
import Banner1 from '../../assets/image/ram-charam.png'
import customer from '../../assets/image/values/search.png'
import innovative from '../../assets/image/values/innovative.png'
import learn from '../../assets/image/values/learn.png'
import streched from '../../assets/image/values/streched.png'
import csr1 from '../../assets/image/csr/csr1.png'
import csr2 from '../../assets/image/csr/csr2.png'
import csr3 from '../../assets/image/csr/csr3.png'
import csr4 from '../../assets/image/csr/csr4.png'
import csr5 from '../../assets/image/csr/csr5.png'
import csr6 from '../../assets/image/csr/csr6.png'
import {Button } from '@material-ui/core'
import ReactGA from 'react-ga';
import {TRACKING_ID} from '../../service/base_url'
export default class index extends Component {
    // asdf
    render() {
        const image=[
            {image:Banner1},
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <div className='aboutus-section'>
                    <Banner image={image} title="We enhance your Execution Capability" subtitle="We help you transform you organization’s execution capability through Strategy, Process, Structure, People, and Culture"/>
                    <br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                    <div className='content-section'>
                        <h2>About Us</h2>
                        <br/><br className='hide-mobile'/>
                        <div className='text-section'>
                            <p>
                            GML Performance Consulting  is a management-consulting firm specializing in helping organizations improve their performance through better translation of their strategy into actions. Its vision is to become the leading performance improvement group of companies in Asia, with highly synergistic services which are customized to Asian business environment and culture. Besides full consulting interventions, GML also provides in-house and routine public workshops to help our clients better equip themselves with leading concepts that could help them better translate their strategy into action.
                            </p>
                        </div>
                        <br/><br/>
                        <h2>Our People</h2>
                        <br/><br  className='hide-mobile'/>
                        <div className='grid-people hide-mobile'>
                            <div className='item1 card-statistik'>
                                <h1 >150+</h1>
                                <p>Full time consultants</p>
                                <div className='image-shadow'></div>

                                <div className='list-description'>
                                    <div className='list-bullets-wrapper'>
                                        <div className='list-bullets-card'>
                                            <div className='bullets-card-asdf'></div>
                                        </div>
                                        <div className='list-content'>
                                            <p> 
                                            Comes from various countries such as <b>USA, Finland,</b> and <b>Australia</b> in various industry backgroud
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div className='list-bullets-wrapper'>
                                        <div className='list-bullets-card'>
                                            <div className='bullets-card-asdf'></div>
                                        </div>
                                        <div className='list-content'>
                                            <p>
                                            Comes from world <b>class principals hold Master’s Degree</b>  or above
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div className='list-bullets-wrapper'>
                                        <div className='list-bullets-card'>
                                            <div className='bullets-card-asdf'></div>
                                        </div>
                                        <div className='list-content'>
                                            <p>
                                            Have Multinational Experience
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='item2 card-statistik'>
                                <h1 >50+</h1>
                                <p>Associate consultans</p>
                                <div className='image-shadow2'></div>
                                <div className='list-description2'>
                                    <div className='list-bullets-wrapper'>
                                        <div className='list-bullets-card'>
                                            <div className='bullets-card-asdf'></div>
                                        </div>
                                        <div className='list-content'>
                                            <p>
                                            Have proven consulting experience
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div className='list-bullets-wrapper'>
                                        <div className='list-bullets-card'>
                                            <div className='bullets-card-asdf'></div>
                                        </div>
                                        <div className='list-content'>
                                            <p>
                                            Have an understanding of local culture with regard to global approach
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='item3 card-statistik'>
                                <h1 >40+</h1>
                                <p>Support teams</p>
                                <div className='image-shadow3'></div>
                            </div>
                        </div>
                        <div className='our-people-mobile show-mobile'>
                            <div className='our-people-number'>
                                <h1 >150+</h1>
                                <p>Full time consultans</p>
                                <div className='square-shadow-mobile'></div>
                            </div>
                            <div>
                                <div className='our-people-description'>
                                    <div className='description-bullets-wrapper'><div className='description-bullets'></div></div>
                                    
                                    <div className='description-text'>
                                        <p>Comes from various countries such as <b>USA, Finland,</b> and <b>Australia</b> in various industry backgroud</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='our-people-description'>
                                    <div className='description-bullets-wrapper'><div className='description-bullets'></div></div>
                                    
                                    <div className='description-text'>
                                        <p>Comes from world class <b>principals hold Master’s Degree</b>  or above</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='our-people-description'>
                                    <div className='description-bullets-wrapper'><div className='description-bullets'></div></div>
                                    
                                    <div className='description-text'>
                                        <p>Have <b>Multinational Experience</b></p>
                                    </div>
                                </div>
                            </div>
                            <div className='our-people-number'>
                                <h1 >50+</h1>
                                <p>Associate consultans</p>
                                <div className='square-shadow-mobile'></div>
                            </div>
                            <div>
                                <div className='our-people-description'>
                                    <div className='description-bullets-wrapper'><div className='description-bullets'></div></div>
                                    
                                    <div className='description-text'>
                                        <p>Have proven consulting experience</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='our-people-description'>
                                    <div className='description-bullets-wrapper'><div className='description-bullets'></div></div>
                                    
                                    <div className='description-text'>
                                        <p>Have an <b>understanding</b> of local culture with regard to global approach</p>
                                    </div>
                                </div>
                            </div>
                            <div className='our-people-number'>
                                <h1 >40+</h1>
                                <p>Support teams</p>
                                <div className='square-shadow-mobile'></div>
                            </div>
                        </div>
                        <br/><br className='hide-mobile'/>
                        <h2>Our Vision</h2>
                        <br/><br/>
                        <div className='text-section'>
                            <p>
                                Most preferred transformation consulting firm in Indonesia, known for results by its clients and professional growth by its associates.
                            </p>
                        </div>
                        <br/><br/>
                        <h2>Our Mision</h2>
                        <br/><br/>
                        <div style={{position:'relative'}}>
                        <div className='text-section'>
                            <p>
                             We enhance our client EXECUTION CAPABILITY to a new level by transforming their strategy, process, structure, people and culture, integrated with digital capability that impact our NATION’s competitiveness.
                            </p>
                        </div>
                        <div className='mission-dot-wrapper hidden-mobile'>
                            <div className='mission-dot'></div>
                            <div className='mission-dot'></div>
                        </div>
                        </div>

                        <br/><br/>
                        <h2>Our Values</h2>
                        <br/><br/>
                        <div className='grid-values-wrapper'>
                            <div className='values-top'>
                                <h1>Disciplined, Growth, Balanced, Engaged</h1>
                            </div>
                            <div className='values-grid'>
                                <img src={innovative}/>
                                <br/>
                                <b>Innovative</b>
                                <br/><br/>
                                <p>We continuously, improve, & develop new ideas & ways of doing things in digital environment with a dare  to fail attitude</p>
                            </div>
                            <div className='values-grid'>
                                <img src={streched}/>
                                <br/>
                                <b>Stretched & Accountable</b>
                                <br/><br/>
                                <p>We are optimistic and ambitious in setting goals and strive hard with empowerment and accountability in achieving it</p>
                            </div>
                            <div className='values-grid'>
                                <img src={learn}/>
                                <br/>
                                <b>Learn & Relearn</b>
                                <br/><br/>
                                <p>We are passionate learners and adaptive in relearning latest knowledge to preserve our though leadership capabilities</p>
                            </div>
                            <div className='values-grid'>
                                <img src={customer}/>
                                <br/>
                                <b>Customer Focus</b>
                                <br/><br/>
                                <p>We put customer first in prioritizing our activities</p>
                            </div>
                            <div className='values-down'>
                                <div>
                                    <h1>Collaborative, Servant Leadership, Bhinneka </h1>
                                    <br/>
                                    <p>We work well within and across functional team with servant-hood, high<br/> integrity spirit and respectfull relationship regardless of differences</p>
                                </div>
                            </div>
                        </div>
                        <br/><br/>
                        <h2 className='hide-mobile'>Our Corporate Social Responsibilities</h2>
                        <br /><br />
                        <div className='csr hide-mobile'>
                            <div className='csr-banner'>
                                <img src={csr1}/>
                                <p>Since its establishment, GML Performance Consulting is well aware of its social responsibility to the communities. As GML grows, we believe we should focus not only on our business in serving customer, but also on creating positive impact on our society. GML always works toward to increase the welfare of the nation by giving a long term aid to educational sector in society. We believe the future of our nation lie in the future of our children. GML provides consistent, multi-year support to underprivileged children through sponsorships of children education and adoption of early-childhod schools in poor communities.</p>
                                
                            </div>
                            <br/>
                            <div className='csr-item'>
                                <div className='csr-item-text'>
                                    <h3>Student Mentoring </h3>
                                    <br/>
                                    <p>GML Performance Consulting participated in a small training to students in TK Mandiri such as dental health and toothbrushing, learning to read, and giving some additional knowledge and learning activities outside school activites. The purpose of this program is to provide a simple insight to students in a fun, entertaining, and exciting way.</p>
                                    <br/><br/>
                                    <h3>CSR Event</h3>
                                    <br/>
                                    <p>In addition to learning activities and monitoring programs, GML Performance Consulting also regularly conduct field trip agenda with TK Mandiri. This activity aims to give students an educated and attractive entertainment.The students are invited to a recreational place that provide social knowledge, culture, environment, and teaching them about what they want to be.</p>
                                </div>
                                <div className='csr-item-image'>
                                    <img src={csr2} className='csr2'/>
                                    <img src={csr3} className='csr3'/>
                                    <img src={csr4} className='csr4'/>
                                    
                                    <img src={csr5} className='csr5'/>
                                    <img src={csr6} className='csr6'/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='corporate-social-mobile show-mobile'>
                            <div className='csr-banner-mobile'>
                                <img src={csr1}/>
                                <h1>Our Corporate Social</h1>                                
                            </div>
                            <br/>
                            <div className='csr-mobile-text'>
                                <p>Since its establishment, GML Performance Consulting is well aware of its social responsibility to the communities. As GML grows, we believe we should focus not only on our business in serving customer, but also on creating positive impact on our society. GML always works toward to increase the welfare of the nation by giving a long term aid to educational sector in society. We believe the future of our nation lie in the future of our children. GML provides consistent, multi-year support to underprivileged children through sponsorships of children education and adoption of early-childhod schools in poor communities.</p>
                                <br/>
                                <h3>Student Mentoring </h3>
                                <br/>
                                <p>GML Performance Consulting participated in a small training to students in TK Mandiri such as dental health and toothbrushing, learning to read, and giving some additional knowledge and learning activities outside school activites. The purpose of this program is to provide a simple insight to students in a fun, entertaining, and exciting way.</p>
                                <br/><br/>
                                <h3>CSR Event</h3>
                                <br/>
                                <p>In addition to learning activities and monitoring programs, GML Performance Consulting also regularly conduct field trip agenda with TK Mandiri. This activity aims to give students an educated and attractive entertainment.The students are invited to a recreational place that provide social knowledge, culture, environment, and teaching them about what they want to be.</p>
                            </div>
                    </div>
                    <br/><br/>
                    <section className="contact-us hidden-mobile">
                        <div style={{width:450,marginLeft:'8%'}}>
                            <h1>How we can help your organization?</h1>
                        </div>
                        <div>
                            <Button style={{textTransform:'none'}} variant="contained" size="large" className="contact-button" onClick={()=>window.location.assign('/contact')}>Contact Us</Button>
                        </div>
                    </section>
                    {/* <section className="contact-us-mobile show-mobile">
                        <div >
                            <h1>How we can help your organization?</h1>
                        </div>
                        <div style={{width:50,border:'1px solid black'}}>
                            <Button style={{textTransform:'none'}} variant="contained" size="small" className="contact-button" onClick={()=>window.location.assign('/contact')}>Contact Us</Button>
                        </div>
                    </section> */}
                    <section className='contacts-mobile show-mobile'>
                        <div style={{width:'90%',height:'100%',margin:'auto',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <h1>How we can help<br/> your organization?</h1>
                            <Button onClick={()=>window.location.assign('/contact')} style={{textTransform:'none'}} variant="contained" size="small" className="contacts-button-mobile">Contact Us</Button>
                    
                        </div>
                        {/* <Button style={{textTransform:'none'}} variant="contained" size="small" className="contact-button-mobile">Contact Us</Button> */}
                    </section>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
